export default {
  getFields : (state) =>  { return state.fields; },
}
